import { ChartData, ChartOptions, Chart } from "chart.js";
import { Bar, mixins } from "vue-chartjs";
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";

Chart.Tooltip.positioners.cursor = (chartElements, coordinates) => {
    return coordinates;
};
// limit length of x axes text
Chart.scaleService.updateScaleDefaults("category", {
    ticks: {
        callback: (tick: string) => {
            let suffix: string = "";
            if (tick.length > 5) {
                suffix = "...";
            }
            return tick.substring(0, 5) + suffix;
        },
    },
});
@Component({
    extends: Bar, // this is important to add the functionality to your component
})
export default class BarChart extends Mixins(mixins.reactiveProp, Bar) {
    @Prop() options!: ChartOptions;
    @Prop() chartData!: ChartData;

    public get gradient() {
        const canvas = this.$refs.canvas as HTMLCanvasElement;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const ctx: CanvasRenderingContext2D = canvas.getContext("2d")!;
        const gradient: CanvasGradient = ctx.createLinearGradient(0, 0, 0, 450);
        gradient.addColorStop(0.5, "#ebd4ff");
        gradient.addColorStop(
            0,
            (this.$vuetify.theme.themes.light.primary || "").toString()
        );
        return gradient;
    }

    @Watch("chartData")
    public buildChart() {
        if (this.chartData) {
            this.chartData.datasets?.forEach(element => {
                element.backgroundColor = this.gradient;
            });
            // const chart = this.$data._chart;
            // chart.data = this.chartData;
            // chart.options = this.options;
            // chart.update({ duration: 800 });
            this.renderChart(this.chartData, this.options);
        }
    }

    mounted() {
        this.buildChart();
    }
}
